"use client";

import { useEffect } from "react";
import { useSearchParams, usePathname, useRouter } from "next/navigation";
import { trackEvent } from "@/lib/analytics";

export function CheckoutReturnTracker() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    if (searchParams.get("checkout_cancelled") !== "1") return;

    const contextRaw = sessionStorage.getItem("checkout_context");
    if (contextRaw) {
      try {
        const context = JSON.parse(contextRaw);
        trackEvent("checkout_abandoned", {
          plan: context.plan,
          source: context.source,
          utm_source: context.utm_source,
          utm_campaign: context.utm_campaign,
          utm_content: context.utm_content,
          utm_medium: context.utm_medium,
        });
      } catch {}
      sessionStorage.removeItem("checkout_context");
    } else {
      trackEvent("checkout_abandoned");
    }

    const params = new URLSearchParams(searchParams.toString());
    params.delete("checkout_cancelled");
    const clean = params.toString();
    router.replace(`${pathname}${clean ? `?${clean}` : ""}`, { scroll: false });
  }, [searchParams, pathname, router]);

  return null;
}
